module.exports = __webpack_public_path__ + "static/cube8-573bf47fb480db87799cb9ff722eb6dd.svg";